<div class="sticky-navbar">
  <nav class="navbar navbar-light bg-faded">
    <ul class="nav navbar-nav">
      <li class="nav-item">
        <a class="nav-link" routerLink="/">
          <div>
            <i class="fa fa-home"></i> {{ "app.title" | translate }}
          </div>
        </a>
      </li>
    </ul>
    <ng-container [ngTemplateOutlet]="this[nvbService.amSuiteFilter | async]"></ng-container>
    <ng-container *ngTemplateOutlet="mobileNavbar"></ng-container>
  </nav>
</div>

<ng-template #GenericFilter>
</ng-template>


<!-- Template for mobile view navbar -->
<ng-template #mobileNavbar>
  <div class="container-fluid mobile-navbar">
    <div class="row">
      <button type="button" class="btn btn-sm btn-default" (click)="toggleMobileSidebar()">
        <i class="fa fa-bars"></i>
      </button>
    </div>
  </div>
</ng-template>

<!-- Component of the sidebar on mobile view -->
@if (sidebarSrv.toggleMobile | async) {
  <sidebar-mobile></sidebar-mobile>
}
